import request from "@/service";

/* 查询审核列表 */
export function videoAuditList(data) {
  return request({
    url: "/resource/resource/audit/page",
    method: "get",
    params: data
  });
}

// 获取审核记录
export function auditHistoryList(id) {
  return request({
    url: `/resource/resource/audit/list/${id}`,
    method: "get"
  });
}
export function findStepTwoUserInfo() {
  return request({
    url: `/user/user/audit/findStepTwoUserInfo`,
    method: "get"
  });
}

// 更新审核记录
export function auditHistoryUpdate(data) {
  return request({
    url: `/resource/resource/audit/update`,
    method: "put",
    data
  });
}

// 获取视频审核人列表
export function videoAuditorList(id) {
  return request({
    url: `/user/sys/user/videoAuditorList/${id}`,
    method: "get"
  });
}
